import { h } from 'preact';
import { accessNested } from 'utils/utils';
import * as BaseComp from 'base/bolt/boltApp.js';
import SignupBanner from 'components/bolt/signupBanner/signupBanner';
import qs from 'qs';

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state.showBanner = false;

		this.signupBanner = accessNested(props, 'initialStore.appData.options.NTLiveFeatures.signupBanner');

		this.showBanner  = this.showBanner.bind(this);
		this.closeBanner = this.closeBanner.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();

		const cookiePresent = document.cookie.split('; ').find(row => row.startsWith('signupBannerSeen'));
		const query = qs.parse(window.location.search.substring(1));
		const showBanner = query.utm_source !== 'SilverpopMailing' && query.hideBanner !== 'true';

		if (cookiePresent || !showBanner) {
			return;
		}

		this.timeout = window.setTimeout(() => {
			this.showBanner();
		}, 20000);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		window.clearTimeout(this.timeout);
	}

	showBanner() {
		this.setState({ showBanner: true });
	}

	closeBanner() {
		this.setState({ showBanner: false });
	}

	getExtra() {
		const { showBanner, appState } = this.state;
		const client = accessNested(appState, 'client');
		if (this.signupBanner) {
			return <SignupBanner data={this.signupBanner} close={this.closeBanner} show={showBanner} client={client} />;
		}
	}
}
